import voucherReportPrintAPI from '@/apis/report/voucherReportPrintAPI';
import designReportAPI from '@/apis/report/designReportAPI';
import { showError } from '@/commons/globalMessage';
import commonFn from '@/commons/commonFunction';
import popupUtil from '@/commons/popupUtil';

export const printVoucher = {
  data() {
    return {
      isReportEdited: false, //hmduc2: 20/11/2023 check xem báo cáo là mẫu sửa hay mẫu mặc định
      apiUse: null, //hmduc2: 20/11/2023 Api được sử dụng
    };
  },
  computed: {},
  methods: {

    /**
     * Hàm gọi request check xem là báo cáo là mẫu sửa hay mẫu mặc định
     * @param {*} id  Id báo cáo
     * @param {*} fileName tên file báo cáo
     * hmduc2: 20/11/2023
     */
     async checkEdited(id, fileName){
        var result = await designReportAPI.checkReportEdited(id,true,fileName);
       return result;
    },

    /**
     * Thực hiện in
     * @param {*} report Báo cáo nào
     * @param {*} param Tham số in
     * @param {*} close Đánh dấu để khi đóng màn hình in báo cáo thì đóng luôn form tham số
     */
     async print(report, param, close) {
       const me = this;

       // hmduc2: 20/11/2023 : Case TH không tick xem trước khi in ở màn tùy chọn
       if(!param?.DataParam.PrintPreview){
          this.isReportEdited = await this.checkEdited(report.report_id, report.report_file);
           // Nếu mẫu đã sửa gọi designReportAPI, chưa sửa gọi voucherReportPrintAPI
           if(this.isReportEdited){
            this.apiUse = designReportAPI;
           }else{
            this.apiUse = voucherReportPrintAPI;
           }
       }else{
          this.apiUse = voucherReportPrintAPI;
       }

      commonFn.mask();
      //gọi lưu tham số và mở ra preview
      this.apiUse
        .saveParamter(param)
        .then(async result => {
          //không ẩn mask để cho popup preview gọi ẩn đi
          const formName = 'ReportPrintPreview';
          if (!report.print_voucher_preview) {
            commonFn.printPreviewReport(report, result, this.apiUse);
          } else {
            await popupUtil.hide(formName);
            popupUtil.show(formName, {
              report: report,
              key: result,
              param: param,
              options: {
                close: () => {
                  // ldduy 22.1.2024 sửa bug menu không load được mẫu mới khi in lô sửa mẫu
                  if (close && this._formParam && this._formParam.report_id == 'PrintBatch' && typeof this._formParam.options.close == 'function') {
                    this._formParam.options.close();
                    this.loadAsyncPrintBatchMenu();

                  } else if (close) {
                    if(this._formParam && this._formParam.options && typeof this._formParam.options.close == 'function'){
                      this._formParam.options.close();
                    }
                    this.beforeClose();
                  }
                },
              },
            });
          }

          // let link = api.getPrintLink(result);
          // window.open(link);
        })
        .catch(err => {
          commonFn.unmask();
          console.log(err);
          showError(err);
        });
    },
  },
};
